import { BrowserRouter } from 'react-router-dom';
import { AppProviders } from '@/app/providers/AppProviders';
import { ComponentErrorBoundary } from '@/components/shared/ComponentErrorBoundary';
import { Panel } from '@/components/shared/Panel';
import { AppRouter } from '@/routes/AppRouter';

export function App(): JSX.Element {
  return (
    <ComponentErrorBoundary
      fallback={(error) => (
        <div className="auth-page">
          <div className="auth-page__backdrop" />
          <Panel
            title="Woof Woof hit a runtime problem"
            description={error.message || 'A runtime error interrupted the portal before the page could render.'}
            action={
              <button type="button" className="button button--secondary" onClick={() => window.location.reload()}>
                Reload Portal
              </button>
            }
          />
        </div>
      )}
      onError={(error) => {
        console.error('Woof Woof root render failed.', error);
      }}
    >
      <BrowserRouter>
        <AppProviders>
          <AppRouter />
        </AppProviders>
      </BrowserRouter>
    </ComponentErrorBoundary>
  );
}
